import React, {Component} from 'react';
import {getAllPreferences} from "../../services/preferencesService"
import {withRouter} from "react-router-dom";
import Pagination from "../contents/Tables/pagination";
import CRUDTableOptions from "../contents/common/htmlElements/TableComponent/subTableComponents/CRUDTableOptions";
import ShowPreferencesTable from "../contents/Tables/ShowPreferencesTable";
import ButtonLink from "../contents/common/htmlElements/ButtonLink";
import {injectIntl} from "react-intl";
import "./PreferencesTableFrame100.css";

class PreferencesTableFrame100 extends Component {

    _isMounted = false;

    state = {
      locale : this.props.locale,
      userType : this.props.userType,
      isLoading : true,
      preferencesList: {},
      filterString : "",
      NoPreferencesFound : false,
      pageSize:50,
      currentPage:1,
      showInactive : 0,
      sortColumn: { path: "id", order: "asc" },
      apiSummary:{
          totalElements:null,
          totalPages:1,
          currentPage:1,
          pageSize:100,
          elementsInCurrentPage:100
      }
    };


    componentDidMount() {
        this._isMounted = true;
        this.loadDataFromAPI(this.state.currentPage, this.state.pageSize, this.state.filterString);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    isEmptyObject(obj){
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    }

    loadDataFromAPI = async (currentPage, pageSize, filter) => {

        try{
            this.setState({ isLoading: true });
            const {data : preferencesList} = await getAllPreferences( filter )

            if (this._isMounted) {
                this.setState({
                    apiSummary: {
                        totalElements:preferencesList.length,
                        totalPages:1,
                        currentPage:1,
                        pageSize:preferencesList.length,
                        elementsInCurrentPage:preferencesList.length
                    },
                    preferencesList : preferencesList,
                    isLoading : false
                });
            }

        }
        catch(err){
            if (this._isMounted) {
                this.setState({isLoading: false, NoUsersFound: true});
            }
        }
    };


    handlePageChange = page => {
        this.setState({ currentPage: page });
        this.loadDataFromAPI(page, this.state.pageSize, this.state.filterString)
    };

    handleFilterPage = string => {
        this.loadDataFromAPI(1, this.state.pageSize, string)
        this.setState({filterString: string})
    };

    handleSort = sortColumn => {
        this.setState({ sortColumn });
    };

    handlePageSize = pageSize => {
        this.setState({pageSize: parseInt(pageSize.target.value)})
        this.loadDataFromAPI(1, parseInt(pageSize.target.value), this.state.filterString)
    };


    render() {
        const count = this.state.apiSummary.totalElements == null ? 0 : this.state.apiSummary.totalElements;
        const pageSize = this.state.apiSummary.pageSize == null ? 0 : this.state.apiSummary.pageSize;
        const currentPage = this.state.apiSummary.currentPage == null ? 0 : this.state.apiSummary.currentPage;
        const { sortColumn, preferencesList } = this.state;
        const pageSizeOptions = [1,2,3,20,50,100];
        const { formatMessage } = this.props.intl;
        const addNewLink =  "/" + this.state.locale + "/admin/configs/manage-preferences/new";
        const priorityLegend = this.props.intl.locale === "fr"
            ? "Le niveau de priorite determine l'ordre de prise en compte pendant les matchs. Les plus petits chiffres sont analyses en premier. Les reperes recommandes sont 10, 20, 30, 40 et 50, avec la possibilite d'utiliser des valeurs intermediaires comme 15 ou 25."
            : "Priority level defines the order used during matching. Smaller numbers are considered first. Recommended anchors are 10, 20, 30, 40 and 50, with intermediate values such as 15 or 25 when needed.";

        return (
            <div className="container noShowElements">
                <div className="row" style={{marginTop:30}}>

                    <div className="col-md-12">
                        <CRUDTableOptions
                            itemCounts = {count}
                            OnPageFilter = {this.handleFilterPage}
                            OnPageSizeChange = {this.handlePageSize}
                            pageSize = {pageSize}
                            pageSizeOptions = {pageSizeOptions}
                            locale = {this.props.locale}
                        />

                        <div className="alert alert-info preferencesPriorityLegend" role="note">
                            {priorityLegend}
                        </div>

                        <ShowPreferencesTable
                            itemCounts={count}
                            preferencesList={preferencesList}
                            sortColumn={sortColumn}
                            onSort={this.handleSort}
                            isLoading={this.state.isLoading}
                            locale = {this.props.locale}
                        />

                        <ButtonLink
                            link={addNewLink}
                            label={formatMessage({id:"preference.addNewButton"})}
                        />

                        <Pagination
                            itemsCount={count}
                            pageSize={pageSize}
                            currentPage={currentPage}
                            onPageChange={this.handlePageChange}
                            renderFullButtons={false}
                            isLoading={this.state.isLoading}
                        />
                    </div>

                </div>
            </div>
        );
    }
}

export default injectIntl(withRouter(PreferencesTableFrame100));
